const messages = {
  quantity: {
    id: 'admin/promotions.form.benefit.gift.max-quantity.label',
  },
  application: {
    perCart: {
      id: 'admin/promotions.form.benefit.gift.multiplier.inactive',
    },
    perItem: {
      id: 'admin/promotions.form.benefit.gift.multiplier.active',
    },
  },
}

export default messages
